module.exports = __webpack_public_path__ + "static/media/kgp-slide-3.5a3c3174.jpg";